import { memo } from 'react';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// How many units of the reward a creator gets for the dare, e.g. "×3". Restores the figure legacy put
// on both surfaces (the dare card's "Dare rewards" block, and `(3) Game Key` on project cards); the
// redesign had lost it on the creator profile and buried it in a 10px badge on the dare card.
// The tinted chrome carries the emphasis, so the number itself stays moderate.
export const RewardAmountBadge = memo(({ amount, className }) => (<span className={cn('inline-flex shrink-0 items-center rounded-md border border-solid border-neon-green/30 bg-neon-green/15', 'px-2 py-0.5 font-mono text-lg font-bold leading-none text-neon-green', className)}>
		×{amount}
	</span>));
